import { RouteConfig, NavigationGuard } from 'vue-router';
import { AdminRoles } from '@/configs/role';
import { NewsType, newsTypeList, NewsTypes } from '@/configs/news';

const checkNewsType: NavigationGuard = (to, from, next) => {
  console.log(to.params.newsType);
  if (!to.params.newsType) {
    next({
      name: 'news-list',
      params: {
        newsType: NewsTypes.LATEST,
      },
    });
    return;
  }

  if (newsTypeList.includes(to.params.newsType as NewsType)) {
    next();
    return;
  }

  next({
    name: 'news-list',
    params: {
      newsType: NewsTypes.LATEST,
    },
  });
};

const newsRoutes: RouteConfig = {
  path: 'news',
  component: () => import(/* webpackChunkName: 'dashboard.news' */ '@/pages/news/Index.vue'),
  redirect: {
    name: 'news-list',
    params: {
      newsType: NewsTypes.LATEST,
    },
  },
  children: [
    {
      path: ':newsType/list',
      name: 'news-list',
      component: () => import(/* webpackChunkName: 'dashboard.news' */ '@/pages/news/List.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
      beforeEnter: checkNewsType,
    },
    {
      path: ':newsType/create',
      name: 'news-create',
      component: () => import(/* webpackChunkName: 'dashboard.news' */ '@/pages/news/Edit.vue'),
      meta: {
        action: 'create',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
    {
      path: ':newsType/:newsId/edit',
      name: 'news-edit',
      component: () => import(/* webpackChunkName: 'dashboard.news' */ '@/pages/news/Edit.vue'),
      meta: {
        action: 'edit',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
  ],
};

export default newsRoutes;
